<script lang="ts">
    import FormErrors from '$components/Form/FormErrors.svelte';
    import HtmlForm from '$components/Form/HtmlForm.svelte';
    import {
        createForm,
        createOnSubmit,
        type FeedCommentEditFormData,
    } from '$components/Feed/FeedCommentEditFormData.js';
    import { getContainer } from '$components/Context/ContainerContext.js';
    import Row from '$components/Form/Row.svelte';
    import SubmitButton from '$components/Form/SubmitButton.svelte';
    import ButtonEmojiPicker from '$components/Emoji/ButtonEmojiPicker.svelte';
    import type { Emoji } from '$components/Emoji/EmojiPicker.svelte';
    import MentionInput from './MentionInput.svelte';
    import Spinner from '$components/Spinner/Spinner.svelte';
    import * as t from '$trans';

    export let body: string;
    export let autoFocus: boolean = false;
    export let commentId: number;

    const container = getContainer();
    const {
        helpers: { addToast },
    } = getContainer().toaster();
    const { lang } = getContainer();

    export let onClose: (() => void) | undefined = undefined;
    export let onSubmitSuccess: ((commentId: number) => void) | undefined = undefined;

    let bodyInputComponent: MentionInput<FeedCommentEditFormData, string> | null = null;

    let [form, fields] = createForm(`EditFeedComment-${commentId}`, { body });

    $: loading = form.stores().isSubmitting();
    $: onSubmit = createOnSubmit(commentId, container);

    function onEmojiSelect(emoji: Emoji) {
        const native = emoji.native;
        if (native != null) {
            bodyInputComponent?.insertEmoji(native);
        }
    }
</script>

<HtmlForm
    class=""
    {form}
    {onSubmit}
    onSubmitSuccess={({ form, data }) => {
        form.dispatch((_type) => form.getInitialState());
        addToast({
            data: {
                type: 'success',
                message: t.feed_post.toast_post_saved_success({}, $lang),
            },
        });
        onSubmitSuccess?.(data.id);
        bodyInputComponent?.clear();
    }}
>
    <Row {form} field={fields.body} label={null} let:field>
        <MentionInput
            bind:this={bodyInputComponent}
            {form}
            {field}
            toText={(id) => id}
            fromText={(id) => id}
            class={''}
            {autoFocus}
        />
    </Row>

    <div class={'my-1 flex items-center items-start_ justify-between'}>
        <ButtonEmojiPicker
            onSelect={onEmojiSelect}
            autocloseAfterSelect={true}
            class="border-none rounded-full text-20 text-gray-800 bg-transparent hover:bg-gray-200 w-12 h-12 inline-flex items-center justify-center"
        />
        <div class="flex items-center gap-2">
            {#if $loading}
                <Spinner size={'sm'} />
            {/if}

            <button
                disabled={$loading}
                on:click|preventDefault={() => onClose?.()}
                class={'btn btn-xs btn-gray rounded-full'}
            >
                <i class="fa fa-times" aria-hidden={true} />
                {t.ui.cancel({}, $lang)}
            </button>
            <SubmitButton
                {form}
                class="btn btn-xs btn-gray rounded-full"
                submittingText="En train de poster..."
                ><i class="fa fa-check" aria-hidden={true} /> {t.ui.save({}, $lang)}
            </SubmitButton>
        </div>
    </div>

    <div class="flex flex-col gap-y-8">
        <FormErrors {form} />
    </div>
</HtmlForm>
